import React from "react";
import ReactDOM from "react-dom";
import Application from "./app";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/antd.less";
import "./utils/i18n";
import { devtools } from "valtio/utils";
import store from "./proxies";
import "./styles.css";
import "./styles.module.scss";
import "@ant-design/flowchart/dist/index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

if (process.env.NODE_ENV === "development") {
  devtools(store, "Store");
}

ReactDOM.render(<Application />, document.getElementById("root"));

reportWebVitals();
serviceWorkerRegistration.register();
